export default __webpack_public_path__ + "static/media/upload.0bfa85fc.svg";